module.exports = __webpack_public_path__ + "img/picture-water.137313bf.jpg";